import { array, boolean, number, object, string } from "yup";

const linkedPriceItemSchema = object({
  price: number().required("Amount is required"),
  description: string().notRequired().default(""),
  frequency: string().notRequired().default(""),
  is_default: boolean().required(),
});

export const addProductAndServiceSchema = () => {
  return object({
    name: string().required("Name is required"),
    type: string().required("Type is required"),
    product_category: string().required("Category is required"),
    linked_price_items: array()
      .of(linkedPriceItemSchema)
      .min(1, "At least one price is required")
      .test("unique-prices", "Each price amount must be unique", (items) => {
        if (!items) return true;
        const prices = items.map((item) => item.price);
        return new Set(prices).size === prices.length;
      })
      .required("At least one price is required"),
    transaction_category_id: string()
      .required("Category is required")
      .nullable(),
  });
};

export const bulkProductImportSchema = () => {
  return object({
    products: array()
      .of(
        object({
          product_name: string().required("Name is required"),
          price: number().required("Price is required"),
          type: string().required("Type is required"),
          category: string().required("Group is required"),
          transaction_category: string().required("Category is required"),
        })
      )
      .min(1, "Add at least one product"),
  });
};
